import {
  KPIDataReportDownloadDTO,
  KPIDataReportEstimateDTO,
  KPIDataReportJobDTO,
  KPIDataReportRequestDTO,
} from 'models/dto/kpi/kpiDataReportDTO';
import {
  KPIDataReportDownload,
  KPIDataReportEstimate,
  KPIDataReportFormat,
  KPIDataReportJob,
  KPIDataReportJobStatus,
} from 'models/kpi/kpiDataReport';
import { fromApiDateTimeOptional, toApiDateTimeRequired } from 'utils/datetime';

export function mapToKPIDataReportRequest(
  kpiIds: number[],
  start: Date,
  end: Date,
  format?: KPIDataReportFormat,
): KPIDataReportRequestDTO {
  const dto = new KPIDataReportRequestDTO();
  dto.kpiIds = kpiIds;
  dto.start = toApiDateTimeRequired(start);
  dto.end = toApiDateTimeRequired(end);
  dto.format = format;

  return dto;
}

export function mapFromKPIDataReportEstimate(dto: KPIDataReportEstimateDTO): KPIDataReportEstimate {
  const estimate = new KPIDataReportEstimate();
  estimate.points = dto.points ?? 0;
  estimate.evidenceRecords = dto.evidenceRecords ?? 0;
  estimate.evidenceBytes = dto.evidenceBytes ?? 0;

  return estimate;
}

export function mapFromKPIDataReportJob(dto: KPIDataReportJobDTO): KPIDataReportJob {
  const job = new KPIDataReportJob();
  job.jobId = dto.jobId;
  job.status = dto.status as KPIDataReportJobStatus;
  job.format = dto.format as KPIDataReportFormat;
  job.kpiIds = dto.kpiIds ?? [];
  job.start = fromApiDateTimeOptional(dto.start);
  job.end = fromApiDateTimeOptional(dto.end);
  job.created = fromApiDateTimeOptional(dto.created);
  job.started = fromApiDateTimeOptional(dto.started ?? undefined);
  job.completed = fromApiDateTimeOptional(dto.completed ?? undefined);
  job.queuePosition = dto.queuePosition ?? 0;
  job.rowsWritten = dto.rowsWritten ?? 0;
  job.rowsTotal = dto.rowsTotal ?? undefined;
  job.evidenceRows = dto.evidenceRows ?? 0;
  job.fileName = dto.fileName ?? undefined;
  job.bytes = dto.bytes ?? undefined;
  job.error = dto.error ?? undefined;
  job.omittedKpiIds = dto.omittedKpiIds ?? [];
  job.expired = dto.expired === true;
  job.savedLinkId = dto.savedLinkId ?? undefined;
  job.savedListId = dto.savedListId ?? undefined;
  job.savedFolderName = dto.savedFolderName ?? undefined;

  return job;
}

export function mapFromKPIDataReportDownload(dto: KPIDataReportDownloadDTO): KPIDataReportDownload {
  const download = new KPIDataReportDownload();
  download.url = dto.url;
  download.fileName = dto.fileName;
  download.expiresOn = fromApiDateTimeOptional(dto.expiresOn);

  return download;
}
